(() => {
  const styleId = 'whealth-compact-review-styles';
  const css = `
    .es-header-component-top { margin-bottom:14px!important; }
    .es-header-container { padding:12px!important; min-height:0!important; height:auto!important; }
    .es-header-rating .es-rating-value { font-size:36px!important; line-height:1!important; }
    .es-header-heading-text { font-size:20px!important; }
    .es-carousel-item, .es-carousel-swiper-wrapper, .es-carousel-inner, .es-carousel-outer, .es-review-container { height:auto!important; min-height:0!important; }
    .es-review-background-container { height:100%!important; padding:16px!important; box-sizing:border-box!important; }
    .es-review-align-container, .es-ai-summary-content-container { height:auto!important; min-height:0!important; }
    .es-review-author-block-container { margin-bottom:12px!important; }
    .es-review-content { font-size:14px!important; line-height:1.45!important; }
    .es-review-content-line-shortener:has(.es-text-shortener-control-open) .es-text-shortener { max-height:calc(1.45em * 5)!important; overflow:hidden!important; display:-webkit-box!important; -webkit-box-orient:vertical!important; -webkit-line-clamp:5!important; }
    .es-review-content-text-container { max-height:none!important; }
    .es-reviews-images-container { height:88px!important; margin-top:12px!important; }
    .es-reviews-images-image-container { height:88px!important; min-height:0!important; max-height:88px!important; }
    .es-reviews-images-image { height:88px!important; width:100%!important; object-fit:cover!important; }
    .es-ai-summary-list-item { margin-bottom:10px!important; }
    @media(max-width:749px) {
      .es-review-background-container { padding:12px!important; }
      .es-review-content-line-shortener:has(.es-text-shortener-control-open) .es-text-shortener { max-height:calc(1.45em * 3)!important; -webkit-line-clamp:3!important; }
      .es-reviews-images-container, .es-reviews-images-image-container, .es-reviews-images-image { height:64px!important; min-height:0!important; max-height:64px!important; }
      .es-header-container { padding:8px!important; }
    }
  `;
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-whealth-compact-reviews]').forEach((container) => {
      if (container.dataset.compactInitialized) return;
      container.dataset.compactInitialized = 'true';
      let attempts = 0;
      const install = () => {
        const host = container.querySelector('.es-embed-root');
        if (!host || !host.shadowRoot) return false;
        if (!host.shadowRoot.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = css;
          host.shadowRoot.appendChild(style);
        }
        return true;
      };
      if (install()) return;
      const timer = setInterval(() => {
        attempts += 1;
        if (!container.isConnected || install() || attempts >= 150) clearInterval(timer);
      }, 200);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
